__turbopack_context__.v({
  "chip": "hvPq2G_chip",
  "group": "hvPq2G_group",
});
